export default __webpack_public_path__ + "static/media/SFTSchriftedSansTRIAL-ExLightItComp-BF6413e1edb3a54.375e212a.otf";